import { styled } from "@mui/material/styles";

const OrderDriverPopupMain = styled("div")(({ theme }) => ({
  "& input": {
    background: "transparent",
    height: "48px",
    border: "1px solid #E8E8E8",
    borderRadius: "4px",
    width: "100%",
    marginBottom: "15px",
    padding: "0 15px",
  },

  "& .css-di73y7-control": {
    height: "48px",
    borderRadius: "4px",
  },
  "& .css-egmddm-control": {
    height: "48px",
    borderRadius: "4px",
  },

  "& button:disabled": {
    background: "rgba(11, 11, 11, .3)",
    color: "#fff",
  },
  "& input:disabled": {
    background: "rgba(240, 240, 240, 1)",
    border: "none",
  },
  "& label": {
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "19px",
    letterSpacing: "-0.02em",
    color: "rgba(11, 11, 11, 0.5)",
  },

  // "& .css-qbdosj-Input": {
  //   height: "29px",
  // },
  // "& .css-1fdsijx-ValueContainer": {
  //   height: "29px",
  // },
}));

export { OrderDriverPopupMain };
